export default __webpack_public_path__ + "static/media/gallery_12.8d84a687.jpg";